$(function () {
    $(document).on('submit', '.form-newsletter', function (e) {
        e.preventDefault();
        var form = $(this);

        $.post(form.attr('action'), form.serialize(), function (data) {
            // console.log(data);
            if (data.result) {
                form.find('input[name="email-newsletter"]').val('');
                form.find('input[name="privacy"]').prop(':checked', false);
                form.find('.banner_newsletter-error').addClass('d-none');
                form.find('input[name="email-newsletter"]').removeClass('error');
                form.find('.banner_newsletter-success').removeClass('d-none');

                $("#modal-form-success-newsletter").modal('show');
            } else {
                form.find('input[name="email-newsletter"]').addClass('error');
                form.find('.banner_newsletter-error').removeClass('d-none');
                form.find('.banner_newsletter-success').addClass('d-none');
            }
        });
    });
});